import React from "react";
import { AttributeInnerCardWrapper } from "./styles";
import { Ptag } from "components/core";
import { formatPlanOverviewValue } from "utlis/utils";

function AttributeInnerCard({ title, value, width }) {
  return (
    <AttributeInnerCardWrapper width={width}>
      <Ptag fontSize="10px">{title}</Ptag>
      <Ptag fontSize="14px" color="#4a4a4a" fontWeight="700" marginTop="10px">
        {formatPlanOverviewValue(value)}
      </Ptag>
    </AttributeInnerCardWrapper>
  );
}

export default AttributeInnerCard;
